import CouponsContainer from '../../containers/Coupons';

function Coupons() {
  return <CouponsContainer />;
}

export default Coupons;